<template>
  <div :class="$style.skeleton" aria-hidden="true" test-id="column-filter-list-skeleton">
    <div v-for="width in LABEL_WIDTHS" :key="width" :class="$style.row">
      <SCASkeletonItem width="16px" height="16px" border-radius="var(--border-radius-small)" />
      <SCASkeletonItem :width="`${width}px`" height="var(--size-2xSmall)" border-radius="var(--border-radius-medium)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import SCASkeletonItem from "../../SCASkeletonItem.vue";

const LABEL_WIDTHS = [72, 104, 56, 88];
</script>

<style module lang="scss">
.skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--space-component-gap-xSmall);
}

.row {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: var(--space-component-gap-small);
  height: var(--size-xSmall);
  padding: 0 6px;
}
</style>
